<div class="section">

  @if(step === 1){
  <p class="text-muted-color text-center mb-3">
    <strong>Forgot Password</strong>
  </p>
  }
  @if(step === 2){
  <p class="text-muted-color text-center mb-3">
    <strong>Enter OTP & New Password</strong>
  </p>
  }

  <div class="log-bx-cntnt">
    <div>

      <!-- STEP 1 -->
      @if(step === 1){
      <form [formGroup]="userForm" (ngSubmit)="sendOtp()">

        <div class="input-group removeBackgroud">
          <span class="input-group-addon">
            <i class="glyphicon glyphicon-user"></i>
          </span>

          <input type="text" class="form-control removeBackgroud" id="forgot-username" name="forgot-username" formControlName="username"
            placeholder="Enter email id" />
        </div>

        @if(error){
        <small class="error">
          {{ error }}
        </small>
        }

        <br />

        <button id ="recoverPasswordButton" type="submit" class="btn btn-md btn-primary btn-block defaultBtnColor"
          [disabled]="userForm.invalid || loading">
          Recover

          @if(loading){
          <img alt="loader" style="text-align:center"
            src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
          }
        </button>

        <button id ="backToLoginButton" type="button" (click)="routeToLogin('login')" class="btn btn-md btn-primary btn-block defaultBtnColor">
          Back to Login
        </button>

      </form>
      }

      <!-- STEP 2 -->
       @if(step === 2){
      <form [formGroup]="resetForm" (ngSubmit)="resetPassword()">
        <div class="input-group">
          <span class="input-group-addon ">
            <i class="glyphicon glyphicon-user"></i>
          </span>
          <input id="forgot-username1" type="text" disabled="true" name="username" class="form-control removeBackgroud" placeholder="Username"
            [value]="username">
        </div>

        <div class="input-group">
          <span class="input-group-addon">
            <i class="glyphicon glyphicon-lock"></i>
          </span>

          <input id="forgot-otp" type="text" class="form-control" name="code" formControlName="code" placeholder="Enter OTP" />
        </div>

        <div class=" d-flex align-items-center removeBackgroud">
          <span class="input-group-addon">
            <i class="glyphicon glyphicon-lock"></i>
          </span>

          <div class="password-wrapper flex-grow-1">
            <input  name="newPassword" id="newPassword"  [type]="showNewPassword ? 'text' : 'password'" class="form-control" formControlName="newPassword"
              placeholder="Enter new password" />

            <span class="toggle-icon" (click)="toggleNewPassword()">
              <i [class]="showNewPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
            </span>
          </div>
        </div>
        <div class="col-12">
          @if (resetForm.get('newPassword')?.touched &&
          resetForm.get('newPassword')?.errors) {

          @if (resetForm.get('newPassword')?.errors?.['required']) {
          <small class="error">Password is required</small>
          }

          @if (resetForm.get('newPassword')?.errors?.['pattern']) {
          <small class="error">
            Password must contain:
            1 uppercase, 1 lowercase, 1 number,
            1 special character, and be at least 8 characters long
          </small>
          }
          }
        </div>

        @if(error){
        <small class="error">
          {{ error }}
        </small>
        }

        <br />

        <button id ="resetPasswordButton" type="submit" class="btn btn-md btn-success btn-block defaultBtnColor"
          [disabled]="resetForm.invalid || loading">
          Reset Password

          @if(loading){
          <img alt="loader" style="text-align:center"
            src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
          }
        </button>

        <button id ="backButton" type="button" (click)="step = 1" class="btn btn-md btn-primary btn-block defaultBtnColor">
          Back
        </button>

      </form>
      }
    </div>
  </div>
</div>